import React from 'react';

import useGetSouscriptionActivePolicyQuery from './hooks/useGetSouscriptionActivePolicyQuery.js';
import SouscriptionActivePolicyForm from './SouscriptionActivePolicyForm.jsx';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import { Loading } from '@fasstech/middle-design-system';

const SouscriptionActivePolicy = ({ getMiddleText, middleFeatures }) => {
  const { getSouscriptionActivePolicy, loading: isFetchingGetSouscriptionActivePolicy } =
    useGetSouscriptionActivePolicyQuery();

  if (isFetchingGetSouscriptionActivePolicy) {
    return <Loading />;
  }

  return (
    <SouscriptionActivePolicyForm
      getMiddleText={getMiddleText}
      middleFeatures={middleFeatures}
      project={getSouscriptionActivePolicy}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SouscriptionActivePolicy);
